@if (canShowItem(model.typeOfAntrag)) {
    <div class="angaben__group">
        <div class="angaben__label">Antragsart</div>
        <div class="angaben__value">{{ translate(model.typeOfAntrag.value) }}</div>
        @if (canShowItem(model.aenderungsAntragBuergscheinNummer)) {
            <div class="angaben__value">
                für Bürgschein {{ translate(model.aenderungsAntragBuergscheinNummer.value) }}
            </div>
        }
    </div>
}

@if (canShowItemMultipleInputs(model.auftraggeberTyp, model.auftraggeberName, model.auftraggeberStrasseNr, model.auftraggeberPlz, model.auftraggeberOrt)) {
    <div class="angaben__group">
        @if (canShowItem(model.auftraggeberTyp)) {
            <div class="angaben__label">{{ model.auftraggeberTyp.value }}</div>
        }
        @if (canShowItem(model.auftraggeberName)) {
            <div class="angaben__value">{{ model.auftraggeberName.value }}</div>
        }
        @if (canShowItem(model.auftraggeberStrasseNr)) {
            <div class="angaben__value">{{ model.auftraggeberStrasseNr.value }}</div>
        }
        @if (canShowItem(model.auftraggeberOrt)) {
            <div class="angaben__value">
                @if (canShowItem(model.auftraggeberLand)) {
                    {{ model.auftraggeberLand.value }}-
                }
                @if (canShowItem(model.auftraggeberPlz)) {
                    {{ model.auftraggeberPlz.value }}
                }&nbsp;
                @if (canShowItem(model.auftraggeberOrt)) {
                    {{ model.auftraggeberOrt.value }}
                }
            </div>
        }
    </div>
}

@if (model.auftraggeberTyp.value === 'Öffentlicher Auftraggeber' && model.vertretungsformelChecked) {
    <div class="angaben__group">
        <div class="angaben__label">Vertretungsformel</div>
        @if (canShowItem(model.vertretungsformel1)) {
            <div class="angaben__value">{{ model.vertretungsformel1.value }}</div>
        }
        @if (canShowItem(model.vertretungsformel2)) {
            <div class="angaben__value">vertreten durch {{ model.vertretungsformel2.value }}</div>
        }
        @if (canShowItem(model.vertretungsformel3)) {
            <div class="angaben__value">vertreten durch {{ model.vertretungsformel3.value }}</div>
        }
        @if (canShowItem(model.vertretungsformel4)) {
            <div class="angaben__value">vertreten durch {{ model.vertretungsformel4.value }}</div>
        }
        @if (canShowItem(model.vertretungsformel5)) {
            <div class="angaben__value">vertreten durch {{ model.vertretungsformel5.value }}</div>
        }
        @if (canShowItem(model.auftraggeberName)) {
            <div class="angaben__value">letztlich vertreten durch {{ model.auftraggeberName.value }}</div>
        }
    </div>
}

@if (!printMode) {
    <div class="angaben__button">
        <elem-button icon="icon-edit_1"
                     buttonRole="SMALL"
                     (click)="context.setCreationState(context.STATE_2_AUFTRAGGEBER, false)">Ändern
        </elem-button>
    </div>
}

